// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { toiletCheckQuestionsQuery } from './toiletCheckQuestionQueries'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'
import ToiletCheckQuestionPage from './ToiletCheckQuestionPage'
import StationPage from '../station/StationPage'

const StationToiletCheckQuestionPage = () => (
  <StationPage title={i18n.t('admin.stations.title.toiletCheckQuestions')}>
    {({ station }) => (
      <Query<
        {
          toiletCheckQuestions: Array<ToiletCheckQuestion>
        },
        Record<string, any>
      >
        query={toiletCheckQuestionsQuery}
        variables={{
          stationId: station.id,
        }}
      >
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <ToiletCheckQuestionPage
              data={get(data, 'toiletCheckQuestions')}
              variables={{
                stationId: station.id,
              }}
              stationId={station.id}
            />
          </Loader>
        )}
      </Query>
    )}
  </StationPage>
)

export default StationToiletCheckQuestionPage
